export * as membersAreaSiteConfiguration from '@wix/auto_sdk_members-area_members-area-site-configuration/meta';
export * as santaMember from '@wix/auto_sdk_members-area_santa-member/meta';
